const SkillData = [
  {
    id: 0,
    count: 3,
    date: "Mar 2019",
    sl: [
      {
        color: "red",
        level: "HTML5 & CSS",
      },
      {
        color: "blue",
        level: "JAVASCRIPT",
      },
      {
        color: "red",
        level: "Bootstrap",
      },
    ],
  },
  {
    id: 1,
    count: 2,
    date: "JAN 2020",
    sl: [
      {
        color: "blue",
        level: "LINUX",
      },
      {
        color: "blue",
        level: "C++",
      },
    ],
  },
  {
    id: 2,
    count: 1,
    date: "MAR 2020",
    sl: [
      {
        color: "red",
        level: "BURPSUITE",
      },
    ],
  },
  {
    id: 3,
    count: 3,
    date: "OCT 2020",
    sl: [
      {
        color: "red",
        level: "OWASP TOP 10",
      },
      {
        color: "blue",
        level: "git",
      },
      {
        color: "blue",
        level: "github",
      },
    ],
  },
  {
    id: 4,
    count: 2,
    date: "JAN 2021",
    sl: [
      {
        color: "blue",
        level: "ETHICAL HACKING",
      },
      {
        color: "yellow",
        level: "php",
      },
    ],
  },
  {
    id: 5,
    count: 3,
    date: "APRIL 2021",
    sl: [
      {
        color: "yellow",
        level: "MY-SQL",
      },
      {
        color: "greenyellow",
        level: "NETWORK SECURITY",
      },
      {
        color: "red",
        level: "PYTHON",
      },
    ],
  },
  {
    id: 6,
    count: 2,
    date: "MAR 2022",
    sl: [
      {
        color: "blue",
        level: "FIREBASE",
      },
      {
        color: "blue",
        level: "bash",
      },
    ],
  },
  {
    id: 7,
    count: 1,
    date: "AUG 2022",
    sl: [
      {
        color: "blue",
        level: "FIGMA",
      },
    ],
  },
  {
    id: 8,
    count: 1,
    date: "DEC 2022",
    sl: [
      {
        color: "red",
        level: "ReactJS",
      },
    ],
  },
  {
    id: 9,
    count: 1,
    date: "JAN 2023",
    sl: [
      {
        color: "blue",
        level: "Appwrite",
      },
    ],
  },
  {
    id: 10,
    count: 3,
    date: "MAR 2023",
    sl: [
      {
        color: "blue",
        level: "NodeJS",
      },
      {
        color: "blue",
        level: "ExpressJS",
      },
      {
        color: "blue",
        level: "MongoDB",
      },
    ],
  },
  {
    id: 11,
    count: 3,
    date: "APRIL 2023",
    sl: [
      {
        color: "red",
        level: "Postman",
      },
      {
        color: "red",
        level: "Material UI",
      },
      {
        color: "blue",
        level: "Tailwind CSS",
      },
    ],
  },
  {
    id: 12,
    count: 2,
    date: "July 2023",
    sl: [
      {
        color: "blue",
        level: "TypeScript",
      },
      {
        color: "blue",
        level: "Google Cloud",
      },
    ],
  },
  {
    id: 13,
    count: 2,
    date: "NOV 2023",
    sl: [
      {
        color: "blue",
        level: "Bug Bounty",
      },
      {
        color: "blue",
        level: "Security Tools",
      },
    ],
  },
  {
    id: 14,
    count: 2,
    date: "OCT 2023",
    sl: [
      {
        color: "blue",
        level: "Azure",
      },
      {
        color: "blue",
        level: "AWS",
      },
    ],
  },
];

export default SkillData;
